export default __webpack_public_path__ + "static/media/delete-icon.e215a2af.svg";